import { useContext } from "react"
import { AppMainContext } from "../context/AppMainContext";
import { useNavigate } from "react-router-dom";


export default function TaskItem({item}) {
  const { handleUpdateStatus } = useContext(AppMainContext);
  const nav = useNavigate();
  return (
    <div className="taskItem_div">
      <input className="taskItem_checkbox" type="checkbox" checked={!item.status} onChange={(e)=>{handleUpdateStatus(item.id, !item.status, nav)}}/>
      <h3 className="taskItem_content">{item.content}</h3>
    </div>
  )
}
